/**
 * Compact spins/s throughput label, e.g. `48.2M spins/s`, `1.20B spins/s`.
 *
 * Magnitude suffixes keep the string short and roughly fixed-width so a
 * live-updating readout doesn't reflow the surrounding UI (paired with
 * `tabular-nums` at the call site). Returns `—` for non-finite or
 * non-positive input (e.g. a sub-millisecond run's divide-by-~0).
 */
export function formatThroughput(spinsPerSec: number): string {
  if (!Number.isFinite(spinsPerSec) || spinsPerSec <= 0) return "—";
  if (spinsPerSec >= 1e9) return `${(spinsPerSec / 1e9).toFixed(2)}B spins/s`;
  if (spinsPerSec >= 1e6) return `${(spinsPerSec / 1e6).toFixed(1)}M spins/s`;
  if (spinsPerSec >= 1e3) return `${(spinsPerSec / 1e3).toFixed(1)}K spins/s`;
  return `${spinsPerSec.toFixed(0)} spins/s`;
}
